<template>
  <div v-if="datas">
    <div class="fvlr header" :class="{ fc: !model }">
      <span v-if="model">车型：{{ model }}</span>
      <div v-if="model" class="empty"></div>
      <span> 轮胎规格：{{ datas.spec }}</span>
    </div>
    <Banner :dblclickImage="dblclickImage" :fromTyre="true" />
    <TyrpInfo :datas="datas" :tyrePackageLoyaltyList="tyrePackageLoyaltyList" :couponList="couponList" :notSell="notSell" />
    <ServiceType class="serviceType" :datas="datas.description" />
    <div class="dealer">
      <CurrentDealer from="tyre" :updataDealer="updataDealer" />
    </div>
    <DeatailParams :datas="datas" />
    <GoodsBar :isEnterShoppingCar="isEnterShoppingCar" :isEnable="isEnable" from="tyreDetail" @clickGoodBtn="clickGoodBtn">
      <ConfirmTyre :datas="tyrpInfoDatas" :showTyreNum="showTyreNum" :from="confirmTyreFrom" :type="confirmTyreType" />
    </GoodsBar>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, watch, computed } from 'vue'
import Banner from '@/components/common/Banner.vue'
import TyrpInfo from '@/components/tyre/TyrpInfo.vue'
import ServiceType from '@/components/tyre/ServiceType.vue'
import DeatailParams from '@/components/tyre/DeatailParams.vue'
import CurrentDealer from '@/components/dealer/CurrentDealer.vue'
import GoodsBar from '@/components/common/GoodsBar'
import { getTyresDetail, getDefaultCommoditie, getDefaultDealer } from '@/api/tyre'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import ConfirmTyre from '@/components/shoppingCart/ConfirmTyre'
import typeImg from '@/assets/images/tyre.png'
import dblclickImage from '@/assets/images/14@2x.png'
import { getTyreUsableCounponList } from '@/api/tyre'
import { backTop } from '@/util'
import { getTyreDealer } from '@/util/tyreList'
import { getSession } from '@/util'
import { addShoppingCar } from '@/api/shoppingCar'
import { showToast } from '@/util/couponCollection'
export default {
  name: 'tyreDetail',
  components: {
    Banner,
    TyrpInfo,
    ServiceType,
    CurrentDealer,
    DeatailParams,
    GoodsBar,
    ConfirmTyre
  },
  setup() {
    let route = useRoute()
    let router = useRouter()
    const store = useStore()
    let { currentTyre } = store.state
    let { model, tyreId, cityId, gsCode, tyrePackageLoyaltyList, from, plate } = route.query
    const tyrePackList = tyrePackageLoyaltyList && tyrePackageLoyaltyList.length ? JSON.parse(tyrePackageLoyaltyList) : []
    const state = reactive({
      from: from || null,
      tyrePackageLoyaltyList: tyrePackList,
      dblclickImage: [dblclickImage],
      datas: '',
      isEnterShoppingCar: true,
      isEnable: true,
      model,
      dealerInfo: {},
      max: 1,
      showTyreNum: 0,
      confirmTyreFrom: '',
      confirmTyreType: '',
      couponList: [],
      defaultDealerGSCode: '',
      updataDealer: 0,
      notSell: true,
      cityInfo: getSession('tyreCity') || {
        text: (store.state.locationInfo && store.state.locationInfo.city) || ''
      },
      // 二次请求经销商
      secondDealerFlag: false
    })
    const clickGoodBtn = data => {
      // if (data.type == 'bugNow' || data.type == 'addShoppingCar') {
      //   state.confirmTyreFrom = data.from
      //   state.confirmTyreType = data.type
      //   state.showTyreNum += 1
      // }
      if (data.type == 'toShoppingCar') {
        router.push({ path: '/shoppingCar', query: { event: '查看购物车' } })
      }
      // 立即购买
      data.type == 'bugNow' && toCreateOrder()
      // 加入购物车
      data.type == 'addShoppingCar' && tyreAddShoppingCar()
    }
    const setCurrentGoodsInfo = () => {
      let { datas } = state
      let productName = `${datas.brand.name || ''}  ${datas.moe ? '原配' + datas.moe : ''}
      ${datas.spec} ${datas.load_index}${datas.speed_rating} ${datas.extra_load || ''}${datas.pattern || ''}`
      store.dispatch('setCurrentGoodsInfo', {
        img: typeImg,
        name: productName,
        uniformPrice: datas.msrp,
        id: datas.id,
        loyaltyId: datas.id,
        priceTypeFlag: datas.priceTypeFlag,
        productType: 2,
        shoppingCarDetailId: datas.id
      })
    }
    // 去购买下单页面
    const toCreateOrder = () => {
      let { dealerInfo } = store.state
      if (!dealerInfo.gs_code) {
        showToast('请选择经销商')
        return
      }
      let currentBuyProductInfo = [{ ...tyrpInfoDatas.value, gsCode: dealerInfo.gs_code, count: store.state.stepperOption?.value }]
      store.dispatch('setCurrentBuyProductInfo', currentBuyProductInfo)
      router.push({
        path: '/createOrder',
        query: { from: 'commodityDetails', plate: state.from == 'myLoyaltyTyre' ? plate : null, gs_code: dealerInfo.gs_code, event: '轮胎下单' }
      })
    }
    // 轮胎加入购物车
    const tyreAddShoppingCar = async () => {
      let { dealerInfo } = store.state
      if (!dealerInfo.gs_code) {
        showToast('请选择经销商')
        return
      }
      let params = {
        customerCarId: -1, //车辆编号
        delStatusFlag: 0, //删除状态
        gsCode: dealerInfo.gs_code, //经销商code
        productId: state.datas.id, //商品编号
        productQuantity: store.state.stepperOption.value, //购买商品数量
        productType: 2 //购买商品类型{1:计划2:轮胎}
      }
      try {
        const { productId } = await addShoppingCar(params)
        if (productId) {
          showToast('加入购物车成功')
          state.isShow = false
        }
        store.dispatch('getCountOfShoppingCar')
      } catch (e) {
        showToast(e.message, '加入购物车失败')
      }
    }
    // 计算轮胎弹窗信息
    const tyrpInfoDatas = computed(() => ({
      ...state.datas,
      isShowStep: state.isEnable,
      max: state.max
    }))
    const getDetail = async () => {
      let params = {
        tyreId,
        gsCode: state.defaultDealerGSCode
      }
      let data = await getTyresDetail(params)
      state.datas = data
      setCurrentGoodsInfo()
      store.commit('SETCURRENTTYRE', data)
      getCouponList()
      // 进入页面，显示最顶端
      backTop()
    }
    // 获取轮胎优惠券
    const getCouponList = async () => {
      if (!state.defaultDealerGSCode || state.couponList.length) return
      let params = {
        mbpn: state.datas.mbpn,
        gsCodes: state.defaultDealerGSCode
      }
      state.couponList = await getTyreUsableCounponList(params)
    }
    const getDefaultDealerFn = async () => {
      let { gsCode, customerLoyaltyPlanId } = route.query //如果有，就是扫码进入
      let data = {}
      if (!gsCode || state.secondDealerFlag) {
        let { lat: latitude, lng: longitude } = store.state.position
        let cityName = state.cityInfo.text
        // 获取默认经销商的GSCode
        data = await getDefaultDealer({
          customerLoyaltyPlanId: customerLoyaltyPlanId || '',
          latitude,
          longitude,
          cityId,
          cityName,
          productId: tyreId,
          productType: 2
        })
        gsCode = data.gsCode
      }
      data.gs_code = state.defaultDealerGSCode = gsCode
      store.commit('SETDEARINFO', data)
      getDefaultCommoditieFn()
      getDetail()
    }
    const getDefaultCommoditieFn = async () => {
      let { lat, lng } = store.state.position
      let params = {
        tyreId,
        gsCode: state.defaultDealerGSCode,
        latitude: lat,
        longitude: lng
      }
      // 根据GSCode、tyreId获取经销商的是否售卖此轮胎、距离、库存等信息
      let { list = [], notSell = false } = await getDefaultCommoditie(params)
      let data = list[0]
      let dealer = data?.dealer
      if (!dealer) return
      dealer = await getTyreDealer(list)[0]
      // 经销商是否售卖
      state.notSell = notSell
      if (notSell) {
        // dealer.sales = 0
        // 扫码无售卖，立即进行二次请求
        if (!state.secondDealerFlag) {
          state.secondDealerFlag = true
          showToast('您所在经销商当前无供货</br>请联系工作人员检查库存及时上架', { position: 'middle', duration: 3500, type: 'html' })
          await getDefaultDealerFn()
        } else {
          // 二次请求后任然无售卖，清空经销商手动选
          store.commit('SETDEARINFO', dealer)
          state.updataDealer += 1
        }
      } else {
        //有库存，更新经销商信息
        store.commit('SETDEARINFO', dealer)
        state.updataDealer += 1
        if (state.datas) return
        getDetail()
      }
    }
    watch(
      () => store.state.dealerInfo,
      (n, o) => {
        if (!!n && (!n.id || n.id === o.id)) return
        state.defaultDealerGSCode = n.gs_code
        // 经销商变更，获取对应轮胎的优惠券
        getCouponList()
      }
    )
    watch(
      () => store.state.stepperOption,
      n => {
        state.max = Math.min.apply(Math, [n.max ? n.max : 0, 4])
        state.isEnable = !!n.max
      }
    )
    onMounted(async () => {
      if (gsCode) {
        state.defaultDealerGSCode = gsCode
        getDefaultCommoditieFn()
      } else {
        getDefaultDealerFn()
      }
    })
    return {
      ...toRefs(state),
      tyrpInfoDatas,
      clickGoodBtn
    }
  }
}
</script>

<style lang="scss" scoped>
.serviceType {
  margin: 8px 0;
  text-align: left;
  font-size: 14px;
}
.dealer {
  background: #ffffff;
  padding: 18px 18px 4px;
  margin-bottom: 8px;
  box-sizing: border-box;
  text-align: left;
  :deep(.colLabel) {
    float: left;
  }
}
.header {
  color: #ffffff;
  height: 40px;
  padding: 0 10px;
  font-size: 14px;
  box-sizing: border-box;
  background-color: #3088c5;
}
.empty {
  width: 5px;
}
</style>
